<template>
	<div class="l-body">
		<Top/>
		<div class="wrap" class="ro">
			<div class="l-wrap zheng">
				<div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">常见问题</span></div>
					<div class="faq_changjian" style="cursor:pointer">
						<a @click="change($event)" :class="show==true?'ok':''">安全服务相关问题</a>
						<a @click="change1($event)" :class="show1==true?'ok':''">查询找回相关问题</a>
						<a @click="change2($event)" :class="show2==true?'ok':''">账号服务相关问题</a>
						<a @click="change3($event)" :class="show3==true?'ok':''">其他问题</a>
					</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow1">
					<router-view/>
				</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow">
					<h1><span id="game">{{game}}</span><span>-</span><span id="faqtype">{{antext}}</span></h1>
					<h2>customer service</h2>
					<div class="wentilist" style="width:90%;margin-left:55px">
						<ul id="nav" v-show="show">
						<li class="list"><i></i><a @click="t('sun1')"><h3>微信令宝使用说明</h3></a></li>
						<li class="list"><i></i><a @click="t('sun2')"><h3>微信令宝介绍</h3></a></li>
						<li class="list"><i></i><a @click="t('sun3')"><h3>令宝解绑申请</h3></a></li>
						</ul>
						<ul id="nav" v-show="show1">
						<li class="list"><i></i><a @click="t('sun4')"><h3>物品被盗如何申请找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun5')"><h3>角色恢复</h3></a></li>
						<li class="list"><i></i><a @click="t('sun6')"><h3>物品丢失、物品异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun7')"><h3>买到被盗物品怎么办</h3></a></li>
						<li class="list"><i></i><a @click="t('sun8')"><h3>防盗防骗小常识</h3></a></li>
						</ul>
						<ul id="nav" v-show="show2">
						<li class="list"><i></i><a @click="t('sun25')"><h3>子账号换绑异身份证主账号</h3></a></li>
						<li class="list"><i></i><a @click="t('sun26')"><h3>子账号换绑同身份证主账号</h3></a></li>
						<li class="list"><i></i><a @click="t('sun10')"><h3>证件信息修改</h3></a></li>
						<li class="list"><i></i><a @click="t('sun11')"><h3>停封解封申请</h3></a></li>
						<li class="list"><i></i><a @click="t('sun12')"><h3>账号找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun13')"><h3>修改密码</h3></a></li>
						<li class="list"><i></i><a @click="t('sun14')"><h3>仓库密码找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun15')"><h3>证件号核实</h3></a></li>
						<li class="list"><i></i><a @click="t('sun16')"><h3>视频认证服务</h3></a></li>
						<li class="list"><i></i><a @click="t('sun17')"><h3>账号注销</h3></a></li>
						<li class="list"><i></i><a @click="t('sun9')"><h3>账号身份证信息重置</h3></a></li>
						</ul>
						<ul id="nav" v-show="show3">
						<li class="list"><i></i><a href="https://ro.zhaouc.com/news/gg/11787.html" target="_blank"><h3>举报违规、封停申诉</h3></a></li>
						<li class="list"><i></i><a @click="t('sun19')"><h3>踢线处理</h3></a></li>
						<li class="list"><i></i><a @click="t('sun20')"><h3>登录异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun21')"><h3>预约来访</h3></a></li>
						<li class="list"><i></i><a @click="t('sun22')"><h3>意见建议、问题提交</h3></a></li>
						<li class="list"><i></i><a @click="t('sun23')"><h3>发票开具</h3></a></li>
						</ul>
						<ul id="nav" v-show="show4">
						<li class="list"><i></i><a @click="t('sun24')"><h3>贵宾特权说明</h3></a></li>
						<li class="list"><i></i><a @click="t('vip')"><h3>常见问题说明</h3></a></li>
						<li class="list"><i></i><a @click="tt"><h3>贵宾专属通道</h3></a></li>
						<li class="list"><i></i><a @click="t('vip1')"><h3>免费洗红申请</h3></a></li>
						<li class="list"><i></i><a @click="t('vip2')"><h3>什么是贵宾用户</h3></a></li>
						</ul>
					</div>
					<div class="hujiao" style="float:left;">
						<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
						<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Top from '@/components/top.vue'
  export default {
    name: "common",
    components: {
      Top
    },
	data () {
	  return {
	    id:this.$route.query.id||localStorage.getItem('id'),
	    game:this.$route.query.name||localStorage.getItem('game'),
		qq:false,
		show:true,
		show1:false,
		show2:false,
		show3:false,
		show4:false,
		theshow:true,
		theshow1:false,
		antext:'安全服务相关问题'
	  }
	},
	created() {
	  localStorage.setItem('id',this.id)
	  localStorage.setItem('game', this.game)
	},
	watch: {
		$route(to , from){
			if(to.path=='/common'){
				this.theshow=true
				this.theshow1=false
			}
		}
	 },
	methods:{
	  change(val){
		 this.show=true;
		 this.show1=false;
		 this.show2=false;
		 this.show3=false;
		 this.show4=false
		 this.theshow=true
		 this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change1(val){
	  	this.show1=true;
	  	this.show=false;
	  	this.show2=false;
	  	this.show3=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change2(val){
		this.show2=true;
		this.show1=false;
		this.show=false;
		this.show3=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText 
	  },
	  change3(val){
		this.show3=true;
		this.show1=false;
		this.show2=false;
		this.show=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  t(meg){
		  this.theshow=false
		  this.theshow1=true
		  this.$router.push({path:meg})
	  }
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/common.vue